import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=474c9048"
import script from "./alert.vue?vue&type=script&lang=ts"
export * from "./alert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474c9048')) {
      api.createRecord('474c9048', component.options)
    } else {
      api.reload('474c9048', component.options)
    }
    module.hot.accept("./alert.vue?vue&type=template&id=474c9048", function () {
      api.rerender('474c9048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/alert.vue"
export default component.exports